const { camelCase } = require('lodash');

class SettingsByBreakpointService {
    constructor($q, settings, breakpointsService) {
        this.$q = $q;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    getSettingValueByBreakpoint(group, settingNames) {
        if (this.breakpointsService.isInLargeFormat) {
            return this.settings[camelCase(group)][camelCase(settingNames.largeFormat)];
        }

        if (this.breakpointsService.isInMediumFormat) {
            return this.settings[camelCase(group)][camelCase(settingNames.mediumFormat)];
        }

        if (this.breakpointsService.isInSmallFormat) {
            return this.settings[camelCase(group)][camelCase(settingNames.smallFormat)];
        }

        return undefined;
    }
}

SettingsByBreakpointService.$inject = ['$q', 'Settings', 'BreakpointsService'];

module.exports = { SettingsByBreakpointService };



// WEBPACK FOOTER //
// ./src/common/settings/settings-by-breakpoint.service.js